/**
 * useAutoOpenRow — opens one row's Flow Optimizer drawer on arrival, for the
 * Banks Flow Tree's "Go to Flow Optimiser" deep link (`?flow=`).
 * For Media Devoted | Created By Ciro Autiero
 *
 * Waits for the rows: they arrive per provider, so the target may not be in the
 * first render. Fires ONCE per flow — closing the drawer must not spring it
 * open again, which is what the ref guards (state would re-run the effect).
 */

import { useEffect, useRef } from 'react';
import type { TrackerId } from '@trafficpulse/shared';

import type { OptimizerRow } from '@/features/optimizer-center/optimizer-center.types';

import { findFlowRow } from './find-flow-row';

export function useAutoOpenRow(
  rows: OptimizerRow[],
  flow: string | null,
  open: (row: OptimizerRow) => void,
  provider?: TrackerId,
): void {
  const handled = useRef<string | null>(null);
  useEffect(() => {
    const identity = `${provider ?? ""}:${flow}`;
    if (!flow || handled.current === identity || rows.length === 0) return;
    const row = findFlowRow(rows, flow, provider);
    if (!row) return;
    handled.current = identity;
    open(row);
  }, [rows, flow, open, provider]);
}
